import React, { useState, useEffect, useRef } from "react";
import "./RestaurantEditable.css";
import "../../ui/styles/theme.css";

import { useParams, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import Loader from "../../ui/components/loader/Loader";

import { userService } from "../../api/user";
import { uploadService } from "../../api/upload";

const RestaurantEditable = () => {
   const navigate = useNavigate();
   const [isNavbarActive, setIsNavbarActive] = useState(false);
   const [isHeaderActive, setIsHeaderActive] = useState(false);
   const [isSearchActive, setIsSearchActive] = useState(false);
   const [deliveryBoyMove, setDeliveryBoyMove] = useState(-80);
   const [lastScrollPos, setLastScrollPos] = useState(0);

   // Edit Mode Logic
   const [isEditMode, setIsEditMode] = useState(false);
   const [isSaving, setIsSaving] = useState(false);
   const fileInputRef = useRef(null);
   const [activeImageUploadVariables, setActiveImageUploadVariables] = useState({
      index: null,
      parentKey: null,
      childKey: null
   });

   const { id } = useParams();

   // Auth Check for Edit Mode Visibility
   const [canEdit, setCanEdit] = useState(false);
   const jwt = Cookies.get("jwt");
   const decodedToken = jwt ? jwtDecode(jwt) : null;
   const loggedInEmail = decodedToken?.email;

   const [user, setUser] = useState({
      personalInfo: {
         name: "",
         phone: "",
         whatsapp: "",
         instagram: "",
         facebook: "",
         location: "",
         Timings: "",
         description: "",
         logo_img: "",
      },
      background: [{ background_img: "", background_name: "" }],
      items: [],
      discounts: [],
      testimonial: [],
      special_item: {
         special_name: "",
         special_price: "",
         special_description: "",
         special_img: ""
      }
   });
   const [loading, setLoading] = useState(true);

   // Fetch User Data
   const fetchUserData = async () => {
      try {
         let data;
         // If ID is 'new' or we have a logged-in user, try to fetch by email first
         if ((id === "new" || !id) && loggedInEmail) {
            try {
               data = await userService.getByEmail(loggedInEmail);
            } catch (e) {
               // User not found, fall through to create new if "new"
            }
         } else {
            data = await userService.getById(id);
         }

         if (data) {
            setUser(data);

            // Check if logged in user is the owner
            if (loggedInEmail && data.personalInfo.email === loggedInEmail) {
               setCanEdit(true);
            }

            // Auto-enable edit mode if it's their own site and they just verified
            if (loggedInEmail && data.personalInfo.email === loggedInEmail) {
               // optional: setIsEditMode(true); 
            }

            setLoading(false);
         } else if (id === "new" && loggedInEmail) {
            // User doesn't exist yet, but is logged in and wants a new template
            // We initialize with default data and allow editing
            setCanEdit(true);
            setIsEditMode(true); // Helper to start editing immediately

            // Pre-fill with rich demo data for instant visual feedback
            setUser(prev => ({
               ...prev,
               personalInfo: {
                  ...prev.personalInfo,
                  email: loggedInEmail,
                  name: "My Great Restaurant",
                  description: "Experience the best flavors in town with our authentic cuisine.",
                  location: "123 Food Street, City",
                  phone: "+91 98765 43210",
                  logo_img: "/assets/images/logo_placeholder.png"
               },
               background: [{
                  background_img: "/assets/images/hero-img.png",
                  background_name: "Hero Image"
               }],
               discounts: [
                  {
                     name: "Grand Opening",
                     discount: "20",
                     description: "Get flat 20% off on your first order!",
                     discount_img: "/assets/images/about-banner.png"
                  }
               ],
               items: [
                  {
                     item_name: "Delicious Burger",
                     item_price: "150",
                     item_description: "Juicy patty with fresh vegetables",
                     item_discount: "10",
                     item_image: "/assets/images/food-menu-1.png",
                     item_category: "Fast Food"
                  },
                  {
                     item_name: "Cheese Pizza",
                     item_price: "299",
                     item_description: "Loaded with extra cheese",
                     item_discount: "0",
                     item_image: "/assets/images/food-menu-2.png",
                     item_category: "Main Course"
                  },
                  {
                     item_name: "Chocolate Cake",
                     item_price: "120",
                     item_description: "Rich dark chocolate layer cake",
                     item_discount: "5",
                     item_image: "/assets/images/food-menu-3.png",
                     item_category: "Dessert"
                  }
               ],
               testimonial: [
                  {
                     name: "John Doe",
                     description: "The food was absolutely wonderful, from preparation to presentation, very pleasing.",
                     testimonial_img: "/assets/images/avatar-1.jpg"
                  },
                  {
                     name: "Jane Smith",
                     description: "Great atmosphere and lovely staff. Will definitely come back!",
                     testimonial_img: "/assets/images/avatar-2.jpg"
                  }
               ],
               special_item: {
                  special_name: "Chef's Special Steak",
                  special_price: "450",
                  special_description: "Premium cut grilled to perfection with secret herbs.",
                  special_img: "/assets/images/food-menu-4.png"
               },
               top_dish: [
                  {
                     top_name: "Signature Pasta",
                     top_img: "/assets/images/food-menu-1.png"
                  }
               ],
               upcoming_events: [
                  {
                     event_name: "Live Music Night",
                     event_description: "Enjoy jazz with your dinner.",
                     event_date: "2024-12-25",
                     event_time: "20:00",
                     event_img: "/assets/images/blog-1.jpg"
                  }
               ]
            }));

            setLoading(false);
         } else {
            console.error("User not found");
            setLoading(false);
         }
      } catch (error) {
         console.error("Error fetching user data:", error);
         setLoading(false);
      }
   };

   useEffect(() => {
      fetchUserData();
   }, [id, loggedInEmail]);

   // Handle Scroll
   useEffect(() => {
      const handleScroll = () => {
         if (window.scrollY >= 100) {
            setIsHeaderActive(true);
         } else {
            setIsHeaderActive(false);
         }

         const deliveryBoy = document.querySelector("[data-delivery-boy]");
         if (deliveryBoy) {
            const deliveryBoyTopPos = deliveryBoy.getBoundingClientRect().top;
            if (deliveryBoyTopPos < 500 && deliveryBoyTopPos > -250) {
               let activeScrollPos = window.scrollY;
               if (lastScrollPos < activeScrollPos) {
                  setDeliveryBoyMove((prev) => prev + 1);
               } else {
                  setDeliveryBoyMove((prev) => prev - 1);
               }
               setLastScrollPos(activeScrollPos);
            }
         }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
   }, [lastScrollPos]);

   // INLINE EDITING HANDLERS

   // Handle Text/Input Changes
   const handleTextChange = (e, parentKey, childKey, index = null) => {
      const { value } = e.target;
      setUser(prev => {
         const newData = { ...prev };
         if (index !== null && Array.isArray(newData[parentKey])) {
            newData[parentKey][index] = {
               ...newData[parentKey][index],
               [childKey]: value
            };
         } else if (parentKey && childKey) {
            newData[parentKey] = {
               ...newData[parentKey],
               [childKey]: value
            };
         }
         return newData;
      });
   };

   // Handle Image Upload Trigger
   const triggerImageUpload = (parentKey, childKey, index = null) => {
      if (!isEditMode) return;
      setActiveImageUploadVariables({ parentKey, childKey, index });
      fileInputRef.current.click();
   };

   // Handle Image File Selection
   const handleImageFileChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const { parentKey, childKey, index } = activeImageUploadVariables;

      // Ideally show a loading state for the specific image here

      try {
         const data = await uploadService.uploadImage(file);

         setUser(prev => {
            const newData = { ...prev };
            if (index !== null && Array.isArray(newData[parentKey])) {
               newData[parentKey][index] = {
                  ...newData[parentKey][index],
                  [childKey]: data.imageUrl
               };
            } else if (parentKey && childKey) {
               newData[parentKey] = {
                  ...newData[parentKey],
                  [childKey]: data.imageUrl
               };
            }
            return newData;
         });
      } catch (error) {
         console.error("Image upload failed", error);
         alert("Image upload failed. Please try again.");
      }

      // Reset input
      e.target.value = null;
   };

   // Add New Item (Menu, Testimonial etc)
   const handleAddItem = (arrayName, initialObject) => {
      setUser(prev => ({
         ...prev,
         [arrayName]: [...prev[arrayName], initialObject]
      }));
   };

   // Delete Item
   const handleDeleteItem = (arrayName, index) => {
      if (window.confirm("Are you sure you want to delete this item?")) {
         setUser(prev => ({
            ...prev,
            [arrayName]: prev[arrayName].filter((_, i) => i !== index)
         }));
      }
   };

   // Save All Changes
   const handleSaveChanges = async () => {
      setIsSaving(true);
      try {
         // Ensure id is present for update
         if (!user.id && user._id) user.id = user._id;

         if (id === "new" && !user._id && !user.id) {
            // Create new user
            await userService.create({ email: user.personalInfo.email, personalInfo: user.personalInfo, items: user.items, discounts: user.discounts, testimonial: user.testimonial, background: user.background, special_item: user.special_item, top_dish: user.top_dish, upcoming_events: user.upcoming_events });
         } else {
            // Update existing
            await userService.update(user.personalInfo.email, user);
         }

         alert("Changes saved successfully!");
         setIsEditMode(false);
      } catch (error) {
         console.error("Save error:", error);
         alert("Error saving changes.");
      } finally {
         setIsSaving(false);
      }
   };

   // Customer Actions (Stubs)
   const handleOrderNow = (itemName) => {
      if (isEditMode) return;
      alert(`Order placed for ${itemName}! (Demo: Item added to cart)`);
   };

   const handleBookEvent = (eventName) => {
      if (isEditMode) return;
      alert(`Booking request sent for ${eventName}! (Demo: Booking confirmed)`);
   };

   const toggleNavbar = () => setIsNavbarActive(prev => !prev);
   const toggleSearch = () => {
      setIsSearchActive(prev => !prev);
      document.body.classList.toggle("active");
   };

   if (loading) {
      return <Loader />;
   }

   // Helper to render editable text
   const RenderEditableText = ({ value, parentKey, childKey, index = null, tag = "p", className = "", placeholder = "..." }) => {
      const Tag = tag;
      if (isEditMode) {
         if (tag === "textarea" || className.includes("hero-text") || className.includes("section-text")) {
            return (
               <textarea
                  className={`edit-textarea ${className} editable-text`}
                  value={value || ""}
                  onChange={(e) => handleTextChange(e, parentKey, childKey, index)}
                  placeholder={placeholder}
                  onClick={(e) => e.stopPropagation()}
               />
            );
         }
         return (
            <input
               type="text"
               className={`edit-input ${className} editable-text`}
               value={value || ""}
               onChange={(e) => handleTextChange(e, parentKey, childKey, index)}
               placeholder={placeholder}
               onClick={(e) => e.stopPropagation()}
            />
         );
      }
      return <Tag className={className}>{value || ""}</Tag>;
   };

   // Helper for Price
   const RenderEditablePrice = ({ value, parentKey, childKey, index = null }) => {
      if (isEditMode) {
         return (
            <span className="price editable-text" style={{ display: 'inline-block' }}>
               ₹ <input
                  type="number"
                  style={{ width: '60px', display: 'inline-block' }}
                  value={value || ""}
                  onChange={(e) => handleTextChange(e, parentKey, childKey, index)}
               />
            </span>
         );
      }
      return <span className="price">₹ {value}</span>;
   }

   return (
      <div className={`restaurant-editable-container ${isEditMode ? "edit-mode-active" : ""}`}>

         {/* Hidden File Input for Image Uploads */}
         <input
            type="file"
            ref={fileInputRef}
            className="hidden-file-input"
            onChange={handleImageFileChange}
            accept="image/*"
         />

         {/* EDIT TOOLBAR */}
         {canEdit && (
            <div className="edit-toolbar">
               <button
                  className={`edit-toggle-btn ${isEditMode ? 'active' : ''}`}
                  onClick={() => setIsEditMode(!isEditMode)}
               >
                  <ion-icon name={isEditMode ? "close-outline" : "create-outline"}></ion-icon>
                  {isEditMode ? "Exit Edit Mode" : "Edit Website"}
               </button>

               {isEditMode && (
                  <button
                     className="save-changes-btn"
                     onClick={handleSaveChanges}
                     disabled={isSaving}
                  >
                     <ion-icon name="save-outline"></ion-icon>
                     {isSaving ? "Saving..." : "Save Changes"}
                  </button>
               )}

               <button
                  className="edit-toggle-btn"
                  onClick={() => navigate('/dashboard')}
                  style={{ backgroundColor: '#4f46e5' }}
               >
                  <ion-icon name="grid-outline"></ion-icon>
                  Dashboard
               </button>
            </div>
         )}

         {/* HEADER */}
         <header className={`header ${isHeaderActive ? "active" : ""}`} data-header>
            <div className="container">
               <div className="logo-container-medium">
                  <div
                     className={`logo-wrapper ${isEditMode ? 'editable-image-container' : ''}`}
                     onClick={() => triggerImageUpload('personalInfo', 'logo_img')}
                  >
                     <img
                        src={user.personalInfo?.logo_img || "/assets/images/logo_placeholder.png"}
                        alt="restaurant logo"
                        className="logo-img"
                     />
                  </div>
                  <h1>
                     <RenderEditableText
                        value={user.personalInfo?.name}
                        parentKey="personalInfo"
                        childKey="name"
                        tag="a"
                        className="logo"
                     />
                  </h1>
               </div>

               <nav className={`navbar ${isNavbarActive ? "active" : ""}`} data-navbar>
                  <ul className="navbar-list">
                     <li className="nav-item"><a href="#home" className="navbar-link" onClick={toggleNavbar}>Home</a></li>
                     <li className="nav-item"><a href="#about" className="navbar-link" onClick={toggleNavbar}>About Us</a></li>
                     <li className="nav-item"><a href="#food-menu" className="navbar-link" onClick={toggleNavbar}>Shop</a></li>
                     <li className="nav-item"><a href="#contact" className="navbar-link" onClick={toggleNavbar}>Contact</a></li>
                  </ul>
               </nav>

               <div className="header-btn-group">
                  <button className="search-btn" aria-label="Search" onClick={toggleSearch}>
                     <ion-icon name="search-outline"></ion-icon>
                  </button>
                  <button className="nav-toggle-btn" aria-label="Toggle Menu" onClick={toggleNavbar}>
                     <span className="line top"></span>
                     <span className="line middle"></span>
                     <span className="line bottom"></span>
                  </button>
               </div>
            </div>
         </header>

         <main>
            <article>
               {/* HERO */}
               <section className="hero" id="home">
                  <div className="container">
                     <div className="hero-content">
                        <h2 className="h1 hero-title">
                           <RenderEditableText
                              value={user.personalInfo?.name || "Your Restaurant Name"}
                              parentKey="personalInfo"
                              childKey="name"
                              tag="span"
                           />
                        </h2>

                        <RenderEditableText
                           value={user.personalInfo?.description || "We provide the best food in town. Come and taste the difference."}
                           parentKey="personalInfo"
                           childKey="description"
                           tag="p"
                           className="hero-text"
                        />

                        <button className="btn">Get Started</button>
                     </div>
                     <figure className="hero-banner">
                        <img src="/assets/images/hero-banner-bg.png" alt="" className="w-100 hero-img-bg" />
                        <div
                           className={`hero-img-wrapper ${isEditMode ? 'editable-image-container' : ''}`}
                           onClick={() => triggerImageUpload('background', 'background_img', 0)}
                        >
                           <img
                              src={user?.background[0]?.background_img || "/assets/images/hero-img.png"}
                              width="700" height="637"
                              alt={user?.background[0]?.background_name || "Hero Plate"}
                              className="w-100 hero-img"
                           />
                        </div>
                     </figure>
                  </div>
               </section>

               {/* WHY CHOOSE US (Static for now, can make editable if needed) */}
               <section className="section why-choose-us">
                  <div className="container">
                     <h2 className="h2 section-title">Why Choose Us?</h2>
                     <div className="features-grid">
                        <div className="feature-card">
                           <div className="feature-icon"><ion-icon name="rocket-outline"></ion-icon></div>
                           <h3 className="h3 feature-title">Fast Delivery</h3>
                        </div>
                        <div className="feature-card">
                           <div className="feature-icon"><ion-icon name="shield-checkmark-outline"></ion-icon></div>
                           <h3 className="h3 feature-title">Hygienic Food</h3>
                        </div>
                        {/* Add more static features as in original */}
                     </div>
                  </div>
               </section>

               {/* ABOUT / DISCOUNTS */}
               {(user?.discounts?.length > 0 || isEditMode) && (
                  <section className="section section-divider gray about" id="about">
                     <div className="container">

                        {/* If no discounts and in edit mode, show button to add */}
                        {user.discounts.length === 0 && isEditMode && (
                           <button className="add-item-btn" onClick={() => handleAddItem('discounts', {
                              name: "New Offer", discount: "20", description: "Offer Description", discount_img: ""
                           })}>
                              <ion-icon name="add-circle-outline"></ion-icon> Add Discount Section
                           </button>
                        )}

                        {user?.discounts?.map((discount, index) => (
                           <div key={index} className="about-wrapper" style={{ position: 'relative', marginBottom: isEditMode ? '40px' : '0' }}>
                              {isEditMode && (
                                 <button className="delete-item-btn" onClick={() => handleDeleteItem('discounts', index)}>
                                    <ion-icon name="trash-outline"></ion-icon>
                                 </button>
                              )}

                              <div className="about-banner">
                                 <div
                                    className={isEditMode ? 'editable-image-container' : ''}
                                    onClick={() => triggerImageUpload('discounts', 'discount_img', index)}
                                 >
                                    <img
                                       src={discount.discount_img || "/assets/images/about-banner.png"}
                                       className="w-100 about-img"
                                       alt="Discount"
                                    />
                                 </div>
                              </div>

                              <div className="about-content">
                                 <h2 className="h2 section-title">
                                    <RenderEditableText value={discount.name} parentKey="discounts" childKey="name" index={index} tag="span" />
                                 </h2>
                                 <h2 className="h2 section-title">
                                    <span className="span">
                                       ₹ <RenderEditableText value={discount.discount} parentKey="discounts" childKey="discount" index={index} tag="span" />
                                    </span>
                                 </h2>
                                 <RenderEditableText value={discount.description} parentKey="discounts" childKey="description" index={index} tag="p" className="section-text" />

                                 <RenderEditableText value={discount.description} parentKey="discounts" childKey="description" index={index} tag="p" className="section-text" />

                                 <button className="btn btn-hover" onClick={() => handleOrderNow(discount.name)}>Order Now</button>
                              </div>
                           </div>
                        ))}
                     </div>
                  </section>
               )}

               {/* FOOD MENU */}
               <section className="section food-menu" id="food-menu">
                  <div className="container">
                     <p className="section-subtitle">Popular Dishes</p>
                     <h2 className="h2 section-title">Our Delicious <span className="span">Foods</span></h2>

                     <ul className="food-menu-list">
                        {user?.items?.map((item, index) => (
                           <li key={index}>
                              <div className="food-menu-card">
                                 {isEditMode && (
                                    <button className="delete-item-btn" onClick={() => handleDeleteItem('items', index)}>
                                       <ion-icon name="trash-outline"></ion-icon>
                                    </button>
                                 )}

                                 <div className="card-banner">
                                    <div
                                       className={isEditMode ? 'editable-image-container' : ''}
                                       onClick={() => triggerImageUpload('items', 'item_img', index)}
                                    >
                                       <img
                                          src={item.item_img || "/assets/images/food-menu-1.png"}
                                          width="300" height="300" loading="lazy"
                                          alt={item.item_name} className="w-100"
                                       />
                                    </div>
                                    <div className="badge">{item.item_discount}%</div>
                                    <button className="btn food-menu-btn" onClick={() => handleOrderNow(item.item_name)}>Order Now</button>
                                 </div>

                                 <h3 className="h3 card-title">
                                    <RenderEditableText value={item.item_name} parentKey="items" childKey="item_name" index={index} tag="span" />
                                 </h3>

                                 <div className="price-wrapper">
                                    <p className="price-text">Price:</p>
                                    <RenderEditablePrice value={item.item_price} parentKey="items" childKey="item_price" index={index} />
                                 </div>
                              </div>
                           </li>
                        ))}
                     </ul>

                     {isEditMode && (
                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                           <button className="add-item-btn" onClick={() => handleAddItem('items', {
                              item_name: "New Dish", item_price: "100", item_img: "", item_discount: "0", item_category: "Main"
                           })}>
                              <ion-icon name="add-circle-outline"></ion-icon> Add New Dish
                           </button>
                        </div>
                     )}
                  </div>
               </section>

               {/* SPECIAL ITEM */}
               {(user?.special_item || isEditMode) && (
                  <section className="section special-dish" style={{ backgroundColor: '#fff' }}>
                     <div className="container">
                        <div className="special-dish-content" style={{ textAlign: 'center', marginBottom: '40px' }}>
                           <p className="section-subtitle">Chef's Recommendation</p>
                           <h2 className="h2 section-title">Special <span className="span">Dish</span></h2>
                        </div>

                        <div className="about-wrapper">
                           <div className="about-banner">
                              <div
                                 className={isEditMode ? 'editable-image-container' : ''}
                                 onClick={() => triggerImageUpload('special_item', 'special_img')}
                              >
                                 <img
                                    src={user?.special_item?.special_img || "/assets/images/food-menu-4.png"}
                                    className="w-100 about-img"
                                    alt="Special Dish"
                                    style={{ maxHeight: '400px', objectFit: 'cover', borderRadius: '10px' }}
                                 />
                              </div>
                           </div>
                           <div className="about-content">
                              <h3 className="h3">
                                 <RenderEditableText value={user?.special_item?.special_name} parentKey="special_item" childKey="special_name" tag="span" />
                              </h3>
                              <div className="price-wrapper" style={{ margin: '20px 0', fontSize: '1.5rem', color: 'var(--deep-saffron)' }}>
                                 ₹ <RenderEditableText value={user?.special_item?.special_price} parentKey="special_item" childKey="special_price" />
                              </div>
                              <RenderEditableText value={user?.special_item?.special_description} parentKey="special_item" childKey="special_description" tag="p" className="section-text" />
                              <button className="btn btn-hover" onClick={() => handleOrderNow(user?.special_item?.special_name)}>Ordered Today</button>
                           </div>
                        </div>
                     </div>
                  </section>
               )}

               {/* TESTIMONIALS */}
               <section className="section section-divider white testi">
                  <div className="container">
                     <p className="section-subtitle">Testimonials</p>
                     <h2 className="h2 section-title">Our Customers <span className="span">Reviews</span></h2>

                     <ul className="testi-list has-scrollbar">
                        {user?.testimonial?.map((testimonial, index) => (
                           <li className="testi-item" key={index}>
                              <div className="testi-card">
                                 {isEditMode && (
                                    <button className="delete-item-btn" onClick={() => handleDeleteItem('testimonial', index)}>
                                       <ion-icon name="trash-outline"></ion-icon>
                                    </button>
                                 )}
                                 <div
                                    className={`profile-wrapper ${isEditMode ? 'editable-image-container' : ''}`}
                                    style={{ width: '60px', height: '60px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto 20px' }}
                                    onClick={() => triggerImageUpload('testimonial', 'testimonial_img', index)}
                                 >
                                    <img
                                       src={testimonial.testimonial_img || "/assets/images/avatar-1.jpg"}
                                       alt={testimonial.name}
                                       style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                 </div>
                                 <blockquote className="testi-text">
                                    <RenderEditableText value={testimonial.description} parentKey="testimonial" childKey="description" index={index} tag="p" />
                                 </blockquote>
                                 <h3 className="h4 testi-name">
                                    <RenderEditableText value={testimonial.name} parentKey="testimonial" childKey="name" index={index} tag="span" />
                                 </h3>
                              </div>
                           </li>
                        ))}
                     </ul>

                     {isEditMode && (
                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                           <button className="add-item-btn" onClick={() => handleAddItem('testimonial', {
                              name: "Customer Name", description: "Great food and service!"
                           })}>
                              <ion-icon name="add-circle-outline"></ion-icon> Add Testimonial
                           </button>
                        </div>
                     )}
                  </div>
               </section>

               {/* TOP DISH */}
               {(user?.top_dish?.length > 0 || isEditMode) && (
                  <section className="section top-dish" style={{ backgroundColor: '#f9f9f9' }}>
                     <div className="container">
                        <p className="section-subtitle">Top Rated</p>
                        <h2 className="h2 section-title">Our Top <span className="span">Dishes</span></h2>

                        <div className="food-menu-list" style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '30px' }}>
                           {user?.top_dish?.map((dish, index) => (
                              <div key={index} className="food-menu-card" style={{ maxWidth: '350px', textAlign: 'center', padding: '20px' }}>
                                 {isEditMode && (
                                    <button className="delete-item-btn" onClick={() => handleDeleteItem('top_dish', index)}>
                                       <ion-icon name="trash-outline"></ion-icon>
                                    </button>
                                 )}
                                 <div className={`card-banner ${isEditMode ? 'editable-image-container' : ''}`}
                                    onClick={() => triggerImageUpload('top_dish', 'top_img', index)}>
                                    <img src={dish.top_img || "/assets/images/food-menu-1.png"}
                                       alt={dish.top_name} className="w-100" style={{ borderRadius: '10px', marginBottom: '15px' }} />
                                 </div>
                                 <h3 className="h3 card-title">
                                    <RenderEditableText value={dish.top_name} parentKey="top_dish" childKey="top_name" index={index} tag="span" />
                                 </h3>
                              </div>
                           ))}
                        </div>

                        {isEditMode && (
                           <div style={{ textAlign: 'center', marginTop: '30px' }}>
                              <button className="add-item-btn" onClick={() => handleAddItem('top_dish', {
                                 top_name: "Top Dish", top_img: ""
                              })}>
                                 <ion-icon name="add-circle-outline"></ion-icon> Add Top Dish
                              </button>
                           </div>
                        )}
                     </div>
                  </section>
               )}

               {/* EVENTS */}
               {(user?.upcoming_events?.length > 0 || isEditMode) && (
                  <section className="section event" id="events">
                     <div className="container">
                        <p className="section-subtitle">Mark Your Calendar</p>
                        <h2 className="h2 section-title">Upcoming <span className="span">Events</span></h2>

                        <ul className="food-menu-list" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', justifyContent: 'center' }}>
                           {user?.upcoming_events?.map((event, index) => (
                              <li key={index} style={{ flex: '1 1 300px', maxWidth: '400px' }}>
                                 <div className="food-menu-card" style={{ padding: '20px' }}>
                                    {isEditMode && (
                                       <button className="delete-item-btn" onClick={() => handleDeleteItem('upcoming_events', index)}>
                                          <ion-icon name="trash-outline"></ion-icon>
                                       </button>
                                    )}
                                    <div className={`card-banner ${isEditMode ? 'editable-image-container' : ''}`}
                                       onClick={() => triggerImageUpload('upcoming_events', 'event_img', index)}>
                                       <img src={event.event_img || "/assets/images/blog-1.jpg"} width="300" height="300"
                                          alt={event.event_name} className="w-100" style={{ aspectRatio: '1/1', objectFit: 'cover' }} />
                                    </div>

                                    <h3 className="h3 card-title" style={{ marginTop: '15px' }}>
                                       <RenderEditableText value={event.event_name} parentKey="upcoming_events" childKey="event_name" index={index} tag="span" />
                                    </h3>
                                    <p className="section-text" style={{ marginTop: '10px' }}>
                                       <RenderEditableText value={event.event_description} parentKey="upcoming_events" childKey="event_description" index={index} tag="span" />
                                    </p>
                                    <div style={{ marginTop: '10px', fontWeight: 'bold', color: 'var(--deep-saffron)' }}>
                                       <RenderEditableText value={event.event_date} parentKey="upcoming_events" childKey="event_date" index={index} tag="span" />
                                       {' '} at {' '}
                                       <RenderEditableText value={event.event_time} parentKey="upcoming_events" childKey="event_time" index={index} tag="span" />
                                    </div>
                                 </div>
                              </li>
                           ))}
                        </ul>

                        {isEditMode && (
                           <div style={{ textAlign: 'center', marginTop: '30px' }}>
                              <button className="add-item-btn" onClick={() => handleAddItem('upcoming_events', {
                                 event_name: "New Event", event_description: "Join us!", event_date: "2024-01-01", event_time: "18:00"
                              })}>
                                 <ion-icon name="add-circle-outline"></ion-icon> Add Event
                              </button>
                           </div>
                        )}
                     </div>
                  </section>
               )}


            </article>
         </main>

         {/* FOOTER */}
         <footer className="footer" id="contact">
            {/* Footer content similar to Header/Hero logic for editability if needed */}
            <div className="container">
               <div className="footer-brand">
                  <p className="footer-text">
                     <RenderEditableText value={user.personalInfo?.location} parentKey="personalInfo" childKey="location" tag="span" />
                  </p>
                  <p className="footer-text">
                     <RenderEditableText value={user.personalInfo?.phone} parentKey="personalInfo" childKey="phone" tag="span" />
                  </p>
               </div>
            </div>
         </footer>
      </div >
   );
};

export default RestaurantEditable;
